import React, { useState , useEffect } from "react";
import {FaUsers,FaShoppingCart, FaHistory, FaUndo, FaSearch, FaPlus} from "react-icons/fa";
import { MdPersonAddAlt1 } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { showSuccess, showError,showWarning} from "../../General/Toast";
import { IoEye } from "react-icons/io5";
import {MdVerifiedUser,MdPersonOff,MdCurrencyRupee} from "react-icons/md";

function PurReturnHistory({clientData}) {
     const [searchTerm, setSearchTerm] = useState('');
     const[returnBill ,setReturnBill] = useState([]);
           const [showModal, setShowModal] = useState(false);
     const [selectedPurchase, setSelectedPurchase] = useState(null);

    const fetchPurchaseReturn = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-purchase-return-bill/${clientData.id}`);
      // setReturnBill(res.data);
      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

    setReturnBill(sortedData);
     
    } catch (error) {
      console.log(error);
    }
  };   

   useEffect(() => {
     fetchPurchaseReturn();
  
    }, []);

    const filteredData = Array.isArray(returnBill)
  ? returnBill
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];

  const handleViewItems = (purchase) => {
  setSelectedPurchase(purchase);
  setShowModal(true);
};

const itemList = selectedPurchase?.items
  ? JSON.parse(selectedPurchase.items)
  : [];

  return (
   <>
    <div className="party-container">
       <div className="party-header">
              <h2>All Purchase Return Transaction </h2>
                 <div className="search-box">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder="Search party name..."
                        value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>          
       </div>
                       
    <div className="table-responsive ">
  <table className="table  table-hover text-center">
    <thead >
      <tr >
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Return No</th>
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Return Date</th>
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Party Name</th>
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Party Number</th>
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Ret Against</th>
        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Return Amount</th>

        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }} >View</th>
      </tr>
    </thead>

    <tbody>
      {filteredData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted">
            No Transaction Found
          </td>
        </tr>
      ) : (
        filteredData.map((item, index) => (
          <tr key={item.id}>
            <td>{item.invoiceNo}</td>
            <td>{item.date}</td>
            <td>{item.name}</td>
            <td>{item.mobile}</td>
            <td>{item.inv_against}</td>
            <td>₹ {item.payable || 0}</td>
        <td> 

           <button className="btn-credit" onClick={() => handleViewItems(item)}>
          Retunred Item
          </button>
        </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
  {showModal && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-lg modal-dialog-centered">

      <div className="modal-content">

        {/* Header */}
        <div className="modal-header">
          <h5 className="modal-title">Returned  Items</h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          />
        </div>

        {/* Body */}
        <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
          <table className="table table-sm table-bordered">
            <thead className="table-info">
              <tr >
                <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>SN</th>
                <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Item Name</th>
                <th style={{ backgroundColor: "var(--primary)" ,color: "#fff"}}>Qty</th>
                <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Purchase Price</th>
                <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Sale Price</th>
                <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Tax Rate</th>
                <th style={{ backgroundColor: "var(--primary)" ,color: "#fff"}}>Total</th>
              </tr>
            </thead>

            <tbody>
              {itemList.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name || item.itemName}</td>
                  <td>{item.qty}</td>
                  <td>₹{item.purchase_price}</td>
                  <td>₹{item.sale_price || 0}</td>
                  <td>{item.taxRate}%</td>
                  <td>₹{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            className="btn btn-primary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  </div>
)}
</div>
    </div>
   </>
  )
}

export default PurReturnHistory
